import React from 'react';
import { withStyles } from '@material-ui/core';
import { Alert } from '@ds/react-components';
import { isEmptyString } from 'utils/strings';

const styles = (theme) => ({
  Title: {
    margin: '0px',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '20px',
  },
  List: {
    listStyleType: 'disc',
    margin: '0px',
    padding: '0px 0px 0px 20px',
  },
});

const FormErrorAlert = (props) => {
  const { classes, errorMsg, setErrorMsg } = props;
  const { message, errors } = errorMsg;

  return (
    <>
      {!isEmptyString(errorMsg) ? (
        <Alert
          onClose={() => {
            setErrorMsg('');
          }}
          role="banner"
          variant="error">
          {typeof errorMsg === 'string' && errorMsg}
          {typeof errorMsg === 'object' ? (
            <>
              {' '}
              <div className={classes.Title}>{message}</div>
              <ul className={classes.List}>
                {errors &&
                  errors.map((error, index) => (
                    <li key={index}>{`${error.message}`}</li>
                  ))}
              </ul>
            </>
          ) : (
            <></>
          )}
        </Alert>
      ) : (
        <></>
      )}
    </>
  );
};

export default withStyles(styles)(FormErrorAlert);
